<template>
    <v-dialog
        transition="dialog-bottom-transition"
        v-model="dialog"
        persistent
        max-width="600"
    >
        <v-card flat>
            <v-toolbar dark color="teal" dense flat>
                <v-toolbar-title>
                    Prende En Charge
                </v-toolbar-title>
            </v-toolbar>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    color="teal"
                    depressed
                    outlined
                    dark
                    @click="getBack"
                >
                    {{ $t("common.close") }}
                    <v-icon right>mdi-close</v-icon>
                </v-btn>
                <v-btn
                    color="teal"
                    depressed
                    dark
                    @click="takeInCharge"
                    :loading="loading"
                >
                    Prende En Charge
                    <v-icon right>mdi-car-cruise-control</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {useClaimStore} from "@/stores/Claim.js";
import {useAbsenceRequestStore} from "@/stores/AbsenceRequest.js";
import {useDebtStore} from "@/stores/Debt.js";
import {useRecruitmentRequestStore} from "@/stores/Request/RecruitmentRequest.js";
import {usePaySlipAnnexStore} from "@/stores/PaySlipAnnex.js";
import useTools from "@/use/Tools.js";
import useSharedData from "@/use/SharedData.js";
import useValidation from "@/use/Validation.js";
import useSharedMethod from "@/use/SharedMethod.js";
import axios from "axios";

export default {
    name: "TakeInCharge",
    setup() {
        const claimStore = useClaimStore();
        const absenceRequestStore = useAbsenceRequestStore();
        const debtStore = useDebtStore();
        const recruitmentRequestStore = useRecruitmentRequestStore();
        const paySlipAnnexStore = usePaySlipAnnexStore();

        const {$route} = useTools();
        const {loading, dialog, inputColor, backgroundColor} = useSharedData();
        const {mxRules} = useValidation();
        const {getBack} = useSharedMethod();

        let api = null;
        switch ($route.params.module) {
            case "DEBT":
                api = "debts"
                break;
            case "ABSENCE_REQUEST":
                api = "absenceRequests";
                break;
            case "CLAIM":
                api = "claims";
                break;
            case "ADMIN_REQUEST":
                api = "adminRequests";
                break;
            case "RECRUITMENT_REQUEST":
                api = "recruitmentRequests";
                break;
            case "PAY_SLIP_ANNEX":
                api = "paySlipAnnexes";
                break;
        }

        function takeInCharge() {
            loading.value = true;
            axios.put(`/${api}/takeInCharge/${$route.params.id}`).then(response => {
                switch ($route.params.module) {
                    case "DEBT":
                        debtStore.updateDebt(response.data);
                        break;
                    case "ABSENCE_REQUEST":
                        absenceRequestStore.updateAbsenceRequest(response.data);
                        break;
                    case "CLAIM":
                    case "ADMIN_REQUEST":
                        claimStore.updateClaim(response.data);
                        break;
                    case "RECRUITMENT_REQUEST":
                        recruitmentRequestStore.updateRecruitmentRequest(response.data);
                        break;
                    case "PAY_SLIP_ANNEX":
                        paySlipAnnexStore.updatePaySlipAnnex(response.data);
                        break;
                }
                getBack();
            }).finally(() => {
                loading.value = false;
            });

        }

        return {
            mxRules,
            dialog,
            loading,
            inputColor,
            backgroundColor,
            takeInCharge,
            getBack,
        }
    }
}
</script>

<style scoped>

</style>